import { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import Layout, { Breadcrumb } from "@/components/feature/Layout";
import { usePageMeta } from "@/hooks/usePageMeta";
import { comicApps } from "@/mocks/apps";
import { articles } from "@/mocks/articles";
import AppReview from "./components/AppReview";
import ArticleDetail from "./components/ArticleDetail";

export default function ReviewDetail() {
  const { id = "" } = useParams();
  const app = comicApps.find((a) => a.id === id);
  const article = articles.find((a) => a.id === id);

  const meta = useMemo(() => {
    if (app) {
      return {
        title: `${app.name}漫画软件应用评测`,
        description: app.summary.slice(0, 60),
        canonical: `https://mangao0.github.io/reviews/${id}`,
        jsonLd: {
          "@context": "https://schema.org",
          "@type": "Review",
          name: `${app.name}漫画软件应用评测`,
          description: app.summary,
          itemReviewed: {
            "@type": "SoftwareApplication",
            name: app.name,
            applicationCategory: "EntertainmentApplication",
            aggregateRating: { "@type": "AggregateRating", ratingValue: app.rating, bestRating: 5, ratingCount: 120 },
          },
          author: { "@type": "Organization", name: "漫选社" },
        },
      };
    }
    if (article) {
      return {
        title: `${article.title} - 漫画软件应用评测`,
        description: article.excerpt.slice(0, 60),
        canonical: `https://mangao0.github.io/reviews/${id}`,
        jsonLd: {
          "@context": "https://schema.org",
          "@type": "Article",
          headline: article.title,
          description: article.excerpt,
          datePublished: article.date,
          dateModified: article.date,
          author: { "@type": "Person", name: article.author },
          publisher: { "@type": "Organization", name: "漫选社" },
        },
      };
    }
    return {
      title: "内容不存在 - 漫画软件应用排行大全",
      description: "你访问的内容不存在或已被移除，返回首页查看更多漫画软件应用内容。",
      canonical: "https://mangao0.github.io/reviews",
    };
  }, [app, article, id]);

  usePageMeta(meta);

  if (!app && !article) {
    return (
      <Layout title="未找到">
        <div className="mx-auto flex w-full max-w-6xl flex-col items-center px-4 py-24 text-center md:px-6">
          <h1 className="font-heading text-3xl text-foreground-950">内容不存在</h1>
          <p className="mt-3 text-sm text-foreground-600">你访问的评测不存在或已被移除。</p>
          <Link to="/rankings" className="mt-6 inline-flex items-center gap-1 whitespace-nowrap rounded-lg bg-primary-500 px-6 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600">
            返回排行榜
          </Link>
        </div>
      </Layout>
    );
  }

  const name = app ? app.name : article!.title;

  return (
    <Layout title={name}>
      <Breadcrumb crumbs={[{ label: "首页", to: "/" }, { label: "评测推荐", to: "/reviews" }, { label: name }]} />
      {app ? <AppReview app={app} /> : article ? <ArticleDetail article={article} /> : null}
    </Layout>
  );
}